module.exports = __webpack_public_path__ + "static/media/ad-img.a28e81af.svg";